<template>
  <multiselect v-model="selected" :options="ms_options"
               :allow-empty="false"
               :no-results-label="no_results_label">
    <!-- <template #noResult>
      No result slot.
    </template> -->
    <template #singleLabel="props">
      Option <pre>{{ props }}</pre> selected.
    </template>
  </multiselect>
</template>

<script>
import Multiselect from "VueComponents/Multiselect";

export default {
  components: {
    Multiselect,
  },
  data: () => ({
    selected: null,
    ms_options: [
      { title: "foo", desc: "Foo descr." },
      { title: "bar", desc: "Bar descr." },
      { title: "baz", desc: "Baz descr." },
    ],
    no_results_label: "Can't find anything!",
  }),
};
</script>

<style lang="scss" scoped></style>
